import { buildVoiceNavUrl } from './apiConfig'

export type NormalizeCommandResult = {
  raw: string
  rule_normalized: string
  llm_normalized: string
}

export async function normalizeCommandTranscript(
  baseUrl: string,
  text: string,
  signal?: AbortSignal,
): Promise<NormalizeCommandResult> {
  const res = await fetch(buildVoiceNavUrl(baseUrl, 'voiceNormalize'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text: text.trim() }),
    signal,
  })
  if (!res.ok) {
    throw new Error(`command normalize HTTP ${res.status}`)
  }
  return (await res.json()) as NormalizeCommandResult
}
